'use strict';

var _ = require('lodash');
var DemandPostingApplyOperationService = function DemandPostingApplyOperationService(effectiveValueService) {
  var PERCENTAGE_TO_ABSOLUTE_THRESHOLD = 1;
  function isSource(item, operationData) {
    return item.classGroup === operationData.source;
  }
  function isTarget(item, operationData) {
    return item.classGroup === operationData.target;
  }
  function getOverride(value, dimension, adjType) {
    var result = {};
    if (!dimension || dimension === 'regular') {
      result.userValueRegularRemainingDemandFC = value;
      result.userTypeRegularRemainingDemandFC = adjType;
    } else {
      result.userValueMappedRemainingDemandFC = value;
      result.userTypeMappedRemainingDemandFC = adjType;
    }
    return result;
  }
  function applyRowOverride(rowData, overrideValue, dimension, gridId, adjType) {
    var normalizedValue = adjType === 'P' ? _.round(Math.round(overrideValue * 10000) / 100, 6) : _.round(overrideValue, 3);
    var override = getOverride(normalizedValue, dimension, adjType);
    var overrideRow = _.extend(rowData, override);
    var effectiveValues = effectiveValueService.calculateAll(overrideRow, gridId);
    return _.extend(overrideRow, effectiveValues);
  }
  function applySourceOverride(sourceRow, dimension, gridParams, operationData) {
    var operationValue = operationData.adjustmentData.value;
    var overrideValue = operationValue * -1;
    return applyRowOverride(sourceRow, overrideValue, dimension, gridParams.gridId, 'P');
  }
  function applyTargetOverride(targetRow, sourceRow, dimension, gridParams) {
    if (targetRow) {
      var sourceTransferValue = 0;
      if (!dimension || dimension === 'regular') {
        sourceTransferValue = sourceRow.regularRemainingDemandFC - sourceRow.effectiveRegularRemainingDemandFC;
      } else {
        sourceTransferValue = sourceRow.mappedRemainingDemandFC - sourceRow.effectiveMappedRemainingDemandFC;
      }
      return applyRowOverride(targetRow, sourceTransferValue, dimension, gridParams.gridId, 'A');
    }
  }
  function applySwapOverride(targetRow, sourceRow, dimension, gridParams) {
    if (targetRow && sourceRow) {
      var sourceOldVal, targetOldVal;
      if (!dimension || dimension === 'regular') {
        sourceOldVal = sourceRow.regularRemainingDemandFC;
        targetOldVal = targetRow.regularRemainingDemandFC;
      } else {
        sourceOldVal = sourceRow.mappedRemainingDemandFC;
        targetOldVal = targetRow.mappedRemainingDemandFC;
      }
      var sourceOverrideValue;
      var sourceOverrideType = 'P';
      if (sourceOldVal < PERCENTAGE_TO_ABSOLUTE_THRESHOLD) {
        sourceOverrideValue = targetOldVal - sourceOldVal;
        sourceOverrideType = 'A';
      } else {
        sourceOverrideValue = (targetOldVal - sourceOldVal) / sourceOldVal;
      }
      var targetOverrideValue = sourceOldVal - targetOldVal;
      var targetOverrideType = 'A';
      return {
        sourceRow: applyRowOverride(sourceRow, sourceOverrideValue, dimension, gridParams.gridId, sourceOverrideType),
        targetRow: applyRowOverride(targetRow, targetOverrideValue, dimension, gridParams.gridId, targetOverrideType)
      };
    } else {
      return {
        targetRow: targetRow,
        sourceRow: sourceRow
      };
    }
  }
  function pickFields(item) {
    return _.pick(item, ['marketDemandId', 'entryKey', 'classGroup', 'posName', 'regularRemainingDemandFC', 'userTypeRegularRemainingDemandFC', 'userValueRegularRemainingDemandFC', 'effectiveRegularRemainingDemandFC', 'mappedRemainingDemandFC', 'userTypeMappedRemainingDemandFC', 'userValueMappedRemainingDemandFC', 'effectiveMappedRemainingDemandFC', 'departureDateMoment']);
  }
  function splitSourceTarget(gridData, operationData) {
    return _.chain(gridData).filter(function (item) {
      return isSource(item, operationData) || isTarget(item, operationData);
    }).map(pickFields).groupBy('classGroup').mapValues(function (records) {
      return _.keyBy(records, function (item) {
        return item.marketDemandId + '.' + item.posName;
      });
    }).value();
  }
  function applyOperation(gridData, gridParams, dimension, operationData) {
    var splittedRecords = splitSourceTarget(gridData, operationData);
    _.forEach(splittedRecords[operationData.source], function (sourceRow, key) {
      var targetRow = splittedRecords[operationData.target][key];
      if (sourceRow) {
        if (operationData.adjustmentData.mode === 'SHIFT') {
          splittedRecords[operationData.source][key] = applySourceOverride(sourceRow, dimension, gridParams, operationData);
          splittedRecords[operationData.target][key] = applyTargetOverride(targetRow, sourceRow, dimension, gridParams);
        } else if (operationData.adjustmentData.mode === 'SWAP') {
          var newRecords = applySwapOverride(targetRow, sourceRow, dimension, gridParams);
          splittedRecords[operationData.source][key] = newRecords.sourceRow;
          splittedRecords[operationData.target][key] = newRecords.targetRow;
        }
      }
    });
    return _.chain(splittedRecords).values().map(function (item) {
      return _.values(item);
    }).flatten().value();
  }
  function getOperationParameters(operationData) {
    var source = operationData.sourceProductGroup.selectedItem;
    var target = operationData.targetProductGroup.selectedItem;
    return {
      source: source && source.id ? source.id : source,
      target: target && target.id ? target.id : target,
      adjustmentData: {
        value: operationData.adjAmount.percentageValue,
        type: 'P',
        mode: operationData.shiftSwap.selectedItem.id
      }
    };
  }
  function getUserValues(fieldName, gridData, gridParams, operations, dimension) {
    return _.chain(operations).map(function (operation) {
      return applyOperation(gridData, gridParams, dimension, getOperationParameters(operation));
    }).flatten().compact().transform(function (result, row) {
      result[row.entryKey] = row[fieldName];
      return result;
    }, {}).value();
  }
  function getGridOverrides(gridData, gridParams, operations, dimension) {
    var fieldsToApply = [];
    if (!dimension || dimension === 'regular') {
      fieldsToApply = ['userValueRegularRemainingDemandFC', 'userTypeRegularRemainingDemandFC'];
    } else {
      fieldsToApply = ['userValueMappedRemainingDemandFC', 'userTypeMappedRemainingDemandFC'];
    }
    return _.map(fieldsToApply, function (fieldName) {
      return {
        matchingField: 'entryKey',
        field: fieldName,
        userValues: getUserValues(fieldName, gridData, gridParams, operations, dimension)
      };
    });
  }
  return {
    applyOperation: applyOperation,
    getGridOverrides: getGridOverrides,
    isSource: isSource,
    isTarget: isTarget,
    getOverride: getOverride,
    applyRowOverride: applyRowOverride,
    applySourceOverride: applySourceOverride,
    applyTargetOverride: applyTargetOverride,
    applySwapOverride: applySwapOverride,
    splitSourceTarget: splitSourceTarget
  };
};
DemandPostingApplyOperationService.$inject = ['CalculateEffectiveValueService'];
module.exports = DemandPostingApplyOperationService;